import React, { useState } from "react";
// import PropTypes from "prop-types";
// --- Import Components
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import SubscriptionsList from "./SubscriptionsList/SubscriptionsList";
// --- Import Styles
import "./Subscriptions.sass";
import Toggle from "../../components/Toggle/Toggle";

function Subscriptions() {
  const [showRenew, setShowRenew] = useState(false);

  return (
    <article className="subscriptions">
      <section className="section-title subscriptions__title">
        <h3>My subscriptions</h3>
      </section>
      <ErrorBoundary
        classWrapper="payment-section__error"
        classText="payment-section__error-text"
      >
        <SubscriptionsList showRenew={showRenew} />
        <div className="subscriptions__renew">
          <p className="subscriptions__renew-text">Renew</p>
          <div className="subscriptions__renew-toggle">
            <Toggle
              checked={showRenew}
              onChange={() => setShowRenew(!showRenew)}
              ariaLabel="Auto-renewal toggle"
            />
          </div>
        </div>
      </ErrorBoundary>
    </article>
  );
}

Subscriptions.propTypes = {};

export default Subscriptions;
